import React, { useState } from "react";
import axios from "axios";
import { Button, Form, Modal } from "semantic-ui-react";

export default function SendPAF({ contractId, resending, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [contractorName, setContractorName] = useState("");

  function onSubmit() {
    setLoading(true);
    setError(null);

    const req = {
      contract_id: contractId,
    };

    if (contractorName) {
      req.dealer_name = contractorName;
    }

    axios
      .post(`/send-ach-authorization/`, req)
      .then(() => {
        setLoading(false);
        onClose();
      })
      .then(() => {
        if (resending) {
          setSuccess(true);

          setTimeout(() => {
            onSuccess();
            setSuccess(false);
          }, 1500);
        }

        return onSuccess();
      })
      .catch((err) => {
        setLoading(false);
        setError(err.response.data.ui_message);

        setTimeout(() => {
          setError(null);
        }, 5000);
      });
  }

  function onClose() {
    setOpen(false);
    setLoading(false);
    setError(null);
    setSuccess(false);
    setContractorName("");
  }

  return (
    <div>
      <Button
        content={
          success
            ? "Resent"
            : resending
            ? "Resend Email for Signature"
            : "Email for Signature"
        }
        onClick={() => (resending ? onSubmit() : setOpen(true))}
        size="mini"
        loading={loading}
        basic
        icon={success ? "check circle" : null}
      />
      <Modal size="tiny" open={isOpen} onClose={onClose}>
        <Modal.Content>
          <div>
            <h4>
              BY SIGNING BELOW THE CONTRACTOR REPRESENTS AND WARRANTS TO ATWOOD
              RENTALS HVAC, LLC:
            </h4>
            <ol style={{ fontSize: "1.15em" }}>
              <li>
                Contractor has delivered all equipment, goods and/or services
                and completed any installation included in the contract to the
                satisfaction of the Renter(s).
              </li>
              <li>
                Contractor has positively identified each Renter whose signature
                appears.
              </li>
              <li>
                This Payment Authorization Form has been signed by a duly
                authorized representative of Contractor.
              </li>
            </ol>
          </div>
          <Form size="large">
            <Form.Input
              label="Contractor Name"
              value={contractorName}
              onChange={(e) => setContractorName(e.target.value)}
            />
          </Form>
          {error && <p style={{ color: "red", fontWeight: "bold" }}>{error}</p>}
          {success && (
            <p style={{ color: "green", fontWeight: "bold" }}>
              Email sent to renter
            </p>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button size="small" content="Close" basic onClick={onClose} />
          <Button
            size="small"
            positive
            content={resending ? "Resend Email to Renter" : "Email to Renter"}
            onClick={onSubmit}
            loading={loading}
            disabled={loading || error || !contractorName}
          />
        </Modal.Actions>
      </Modal>
    </div>
  );
}

SendPAF.defaultProps = {
  resending: false,
};
